import styled from "@emotion/styled";
import { css } from "@emotion/react";
import rightCurve from "../../../images/right_curves.svg";

export const MobileMainImageContainer = styled.div`
  .addon {
    top: -58px;
    right: 0;
  }
`;

const MainSectionWrapper = css`
  overflow: hidden;
  .wrapper-parent {
    min-height: 753px;
  }
  .curves-parent {
    background: url(${rightCurve}) center no-repeat;
    width: 1865px;
    height: 622px;
    transform: translate(-82%, 8%);
  }
  .title-lg-parent {
    max-width: 620px;
  }
  .title-parent {
    max-width: 520px;
  }
  .btn-parent {
    max-width: 179px;
  }
  .logos-parent {
    max-width: 1070px;
    .gatsby-image-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin: auto auto auto 0;
    }
  }
  .image-parent {
    .gatsby-image-wrapper {
      max-width: 450px;
    }
  }

  @media screen and (max-width: 767.98px) {
    .image-parent svg {
      max-width: 480px;
    }

    .curves-parent {
      transform: translate(-80%, 50%);
    }
  }

  @media screen and (max-width: 480px) {
    .image-parent svg {
      max-width: 100%;
    }
    .curves-parent {
      transform: translate(-80%, 70%);
    }
  }
`;

export { MainSectionWrapper };
